export const getRandomContext = (list) => {
  return list[Math.floor(Math.random() * list.length)];
};

export const getRandomContextId = (list) => {
  return Math.floor(Math.random() * list.length);
};

export const paintingContexts = [
  'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/398fec89-22f1-49ed-aefd-cd9b9d4d4c38.jpg',
  'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/dec75857-2442-43c3-90b4-56880467f2a1.jpg',
  'https://cdn.wtlstudio.com/common-ptr.wtlstudio.com/fee10c71-3182-4bd0-8e64-74dd71b7fb64.png',
];